import React, { useState } from 'react';
import { links } from '../siteData';
import Icon from './Icon';
import IssuerControl from './IssuerControl';
import { ExternalLink, SocialLinks } from './Shared';

export default function Hero() {
  const [imageFailed, setImageFailed] = useState(false);
  return <section id="home" className="hero hero-eagle" aria-labelledby="hero-title">
    <div className="container hero-inner">
      <div className="hero-art">
        <img className="hero-poster" src={imageFailed ? '/brand/ultra-maga-poster.webp' : '/brand/trump-eagle-hero-v2.png'}
          alt="A bald eagle beside Trump in reflective blue sunglasses, against an American flag"
          onError={() => { if (!imageFailed) setImageFailed(true); }} />
        <div className="art-shade" />
      </div>
      <div className="hero-copy">
        <h1 id="hero-title"><span className="hero-silver">ULTRA</span>{' '}<span className="hero-gold">$MAGA</span></h1>
        <p className="hero-tagline">The People's Token <span className="gold-accent">on XRPL</span></p>
        <p className="hero-description">Community powered. Built on the XRP Ledger.<br />Freedom. Memes. A Stronger Tomorrow.</p>
        <div className="hero-actions"><ExternalLink className="button button-primary" href={links.firstLedger}><Icon name="arrow" /> Buy $MAGA</ExternalLink><ExternalLink className="button button-secondary" href={links.chart}><Icon name="chart" /> View chart</ExternalLink></div>
        <IssuerControl />
        <div className="hero-social"><SocialLinks /><span>Culture. Community. Crypto.</span></div>
      </div>
    </div>
  </section>;
}
